// extracted by mini-css-extract-plugin
export var planTypeContainer = "GiftPlan-module__planTypeContainer___A4FHd";
export var pickYourPlan = "GiftPlan-module__pickYourPlan___w2RBy";
export var cancel = "GiftPlan-module__cancel___FyPaD";
export var card = "GiftPlan-module__card___FYGXI";